

































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { card, project } from "../board";
import { Action, Mutation, State } from "vuex-class";
import DatePicker from "vuejs-datepicker";
const ESC_KEY_CODE = 27;
@Component({
  components: {
    DatePicker
  }
})
export default class CardModal extends Vue {
  @Action private updateCard;
  @Mutation setModalIsActive;
  @Mutation("removeCard") removeCardById;
  @State("selectedCard") card!: card;
  @State("selectedProject") storeSelectedProject!: project;
  @State("modalIsActive") isActive: boolean;

  toggleModal() {
    this.setModalIsActive(!this.isActive);
    if (!this.isActive) {
      this.updateCard(this.card);
    }
  }

  get projectUsers() {
    return this.storeSelectedProject.users;
  }

  removeCard() {
    this.removeCardById(this.card._id);
    this.setModalIsActive(false);
  }

  mounted() {
    window.addEventListener("keyup", (e) => {
      if (e.keyCode === ESC_KEY_CODE) {
        if (this.isActive) {
          this.updateCard(this.card);
        }
        this.setModalIsActive(false);
      }
    });
  }
}
